// frontend/shared-ui/src/forms/schemas/index.js
import odf from './odf';
import cable from './cable';
import sfp from './sfp';
import device from './device';
import splitter from './splitter';
import tool from './tool';
import instrument from './instrument';
import accessory from './accessory';
import spliceProtector from './spliceProtector';
import hardware from './hardware';
import puller from './puller';
import cleaner from './cleaner';
import closure from './closure';                       // ← NEW

export const SCHEMA_BY_SLUG = {
    'odf-patch-panels': odf,
    'splice-closures': closure,                        // ← CHANGED (was odf)
    'patch-cords-pigtails': accessory,
    'drop-cables': cable,
    'connectors-adapters': accessory,
    'splitters-couplers': splitter,
    'ont-onu': device,
    'olt': device,
    'sfp-transceivers': sfp,
    'media-converters': device,
    'test-instruments': instrument,
    'tools-accessories': tool,
    'splice-protectors': spliceProtector,
    'hardware': hardware,
    'pullers': puller,
    'cleaners': cleaner,
};

export {
    odf, cable, sfp, device, splitter, tool, instrument, accessory,
    spliceProtector, hardware, puller, cleaner, closure,   // ← add closure
};

export function getSchemaForCategory(category) {
    if (!category) return null;
    return SCHEMA_BY_SLUG[category.slug] || null;
}